import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, FloatingInput } from '@piplapps/pipl-ui';
import styles from './RenameTeamModal.module.less';
import LoadingButton from '../../../Components/LoadingButton';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import { UsersActions } from '../../../Redux/modules/users/actions';

const CreateTeamModal = (props) => {
  const { teams, title } = props;
  const [name, resetName] = useState('');
  const [error, setError] = useState(null);

  const validateName = () => {
    const teamNames = teams.map((team) => team.name.toLowerCase());
    const hasError = teamNames.includes(name.toLowerCase());
    if (!name || name.trim() === '' || name.trim().length < 2) {
      setError('Name must have at least 2 characters');
    } else if (hasError) {
      setError('This team name already exists');
    } else {
      setError(null);
    }
  };

  const handleSubmit = () => {
    props.onCreateTeam({ name: name.trim() });
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{title}</div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>

      <div className={styles.text}>
        <FloatingInput
          id="id_team_name"
          name="team_name"
          testId="team-name-input"
          placeholder={gettext('Team name')}
          value={name}
          onChange={(e) => resetName(e.target.value)}
          forcedError={error}
          successColor="#8792a9"
          onBlur={validateName}
          autoComplete="off"
          autoFocus
        />
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler eventName={AnalyticsEventNames.CREATE_TEAM} eventData={{ teamName: name }}>
            <LoadingButton
              id="submit-button"
              buttonClass="primary-blue"
              type="submit"
              onClick={() => handleSubmit()}
              text={gettext('Save')}
              disabled={!!error}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

CreateTeamModal.propTypes = {
  title: PropTypes.string,
  onCreateTeam: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
  teams: PropTypes.array,
};

const mapDispatchToProps = {
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
  onCreateTeam: UsersActions.createTeam,
};

export default connect(null, mapDispatchToProps)(CreateTeamModal);
